import React , {useLayoutEffect, useState, useRef} from 'react'
import { FPSInfo , QRTimeOut , QRFormat ,components_css ,QRRenderer , GenerateQRButton, ExcelHandler} from './components'
import resource from '../resource.js'
import apis from '../api.js' 

const addFormData2ExcelData = (data)=>{
    let kvPairs = {}
    kvPairs['PointofInitiationMethod'] = 'PointofInitiationMethod'
    kvPairs['EnableTimeOut'] = 'MerchantTimeOuttimeEnabled'
    kvPairs['TimeoutHH'] = 'MerchantTimeOuttimeHH'
    kvPairs['TimeoutMM'] = 'MerchantTimeOuttimeMM'
    kvPairs['TimeoutSS'] = 'MerchantTimeOuttimeSS' 
    kvPairs['Currency'] = 'TransactionCurrency'
    kvPairs['EditableAmount'] = 'EditableTransactionAmountIndicator'
    
    // add data to extracted excel data 
    data.forEach(row => {
        Object.entries(kvPairs).forEach(pair =>{
            row[pair[0]] = document.getElementById(pair[1]).value 
        });
    });

    return data ;
}

export default function(props){
    document.title=props.title
    
    const inputRef = useRef(null);
    const [qrValue, setQrValue] = useState('');

    // useLayoutEffect(() => {
    //     document.getElementById('TransactionAmount').value = 0 
    // })

    const toggleGenQRButtonState = (_disable)=>{
        document.getElementById('GenButtonContainer')
                .querySelectorAll('button')[0]
                .disabled = _disable
    }

    /*
        get Excel template from api.  
        the function within the api function will prompt user to save the file 
    */
    const downloadTemplate = ()=>{
        apis.getXLSXTemplate('FPS_QR_Code_Batch_Template.xlsx')
    }

    /* 
        Excel Handler component will handle most of the excel parsing an generation tasks 
        A call back within that the handler will call this page to access api when necessary
    */ 
    let clickFileInputButton = ()=>{  
        inputRef.current?.click() 
    }

    /* Call API to generate QR Code values */
    let handleDataReady = async (data)=>{
        /* look at the current form and append exising data to each entry of the json list */
        data = addFormData2ExcelData(data)
        
        console.log(data)
        console.log(`before sending to api: ${Date.now()}`) 
        var apidata = await  apis.getQRCodeBatch( data) 
                .then (resp=> {
                    if( resp.ok ) {  return resp.msg;  }
                    else {  throw new Error ( resp.msg); }
                })
                .catch( e=>{
                    console.log(e) 
                })
        return apidata;
    }

    return( 
        <div style={{
            maxwidth: '50%'
            }} className='form'>
            <h1>Create QR Code</h1>
            <hr/ > 
            <div >
            <b>Download the template for creating the batch of FPS QR Code: </b>
            <a   style={{cursor: 'pointer '}}  onClick={downloadTemplate}   >Download Template</a>
            </div>

            <FPSInfo /> 
            <QRTimeOut />

            <div>
                    <h2>Amount: </h2>
                    <div className="panel" > 
                        <div style={{display: 'none'}}>
                            <label>Currency</label>
                            <select id='TransactionCurrency'> 
                                { 
                                        resource.currency.map((c)=>{
                                    return  <option value={c.val} >{c.text}</option>
                                        }) 
                                }
                            </select> 
                        </div>
                        <label>Editable Amount</label>
                        <select id='EditableTransactionAmountIndicator'>
                            <option value='06011'>Yes</option>
                            <option value=''>No</option>
                        </select>
                    </div>
                </div>
           
            <div  style={{marginTop: '10px' , marginBottom: '20px'}}>
                
                <ExcelHandler  
                        ref={inputRef}  
                        ToggleGenButtonState={toggleGenQRButtonState}
                        excelDataCallback={handleDataReady}  
                        />
                <div id="GenButtonContainer" 
                        style={{marginTop: '10px' , marginBottom: '20px'}}
                    >
                    <GenerateQRButton  
                            onButtonClicked={clickFileInputButton} 
                            />
                </div>

            </div>
        </div>
    )
}

